// Types
export type LineType = 'income' | 'expense' | 'conciliated' | 'wallet';

export interface CashFlowLine {
  // Base fields
  requestTypeTranslated: string;
  businessName: string;
  businessIdentifier: string;
  requestId: string;
  folio: string;
  requestDate: string;
  requestType: string;
  stakeholderIdentifier: string;
  userOwnerId: number;
  operationDate: string;
  status: string;
  userOwnerName: string;
  finalPaymentDate: string;
  originalPaymentDate: string;
  documentType: string;
  // Financial amounts
  amountConciliated: number;
  amountInWallet: number;
  amountInWalletNet: number;
  amountLend: number;
  amountPlaced: number;
  amountPlacedNet: number;

  // Income fields
  arrearIncome: number;
  comissionIncome: number;
  documentExtensionPriceIncome: number;
  documentExtensionCommissionIncome: number;
  documentOtherIncome: number;
  expensesIncome: number;
  priceIncome: number;

  // Expense fields
  documentResellExpense: number;
  paymentDate: string;
  fundName: string;
  stakeholderName: string;

  // Wallet fields
  realAmountInWallet: number;
  realAmountInWalletNet: number;

  // Line types classification
  lineTypes: LineType[];
}

export interface HeaderConfig {
  key: keyof CashFlowLine;
  label: string;
  type?: 'money' | 'date' | 'text' | 'numeric-id';
}

// Headers configuration
export const baseHeaders: HeaderConfig[] = [
  { key: 'requestTypeTranslated', label: 'Tipo de solicitud' },
  { key: 'businessName', label: 'Nombre empresa' },
  { key: 'businessIdentifier', label: 'RUT' },
  { key: 'requestId', label: 'ID/Folio' },
];

export const incomeHeaders: HeaderConfig[] = [
  { key: 'priceIncome', label: 'Interés devengado', type: 'money' },
  { key: 'arrearIncome', label: 'Interés mora', type: 'money' },
  { key: 'comissionIncome', label: 'Monto comisión', type: 'money' },
  { key: 'expensesIncome', label: 'Gastos', type: 'money' },
  {
    key: 'documentExtensionPriceIncome',
    label: 'Prórroga precio',
    type: 'money',
  },
  {
    key: 'documentExtensionCommissionIncome',
    label: 'Prórroga comisión',
    type: 'money',
  },
  { key: 'documentOtherIncome', label: 'Otros', type: 'money' },
];

export const expenseHeaders: HeaderConfig[] = [
  { key: 'documentResellExpense', label: 'Costo fondo', type: 'money' },
];

export const conciliatedHeaders: HeaderConfig[] = [
  { key: 'amountConciliated', label: 'Recaudado', type: 'money' },
];

export const walletHeaders: HeaderConfig[] = [
  { key: 'stakeholderName', label: 'Deudor', type: 'text' },
  { key: 'stakeholderIdentifier', label: 'Rut deudor', type: 'text' },
  { key: 'amountInWallet', label: 'Documento', type: 'money' },
  { key: 'amountInWalletNet', label: 'Documento neto', type: 'money' },
  { key: 'realAmountInWallet', label: 'Total colocado', type: 'money' },
  { key: 'realAmountInWalletNet', label: 'Total colocado neto', type: 'money' },
  { key: 'amountPlaced', label: 'Monto colocado', type: 'money' },
  { key: 'amountPlacedNet', label: 'Monto colocado neto', type: 'money' },
  { key: 'operationDate', label: 'Fecha operación', type: 'date' },
  { key: 'originalPaymentDate', label: 'Vencimiento original', type: 'date' },
  { key: 'finalPaymentDate', label: 'Vencimiento final', type: 'date' },
  { key: 'fundName', label: 'Fondo', type: 'text' },
  { key: 'status', label: 'Estado', type: 'text' },
  { key: 'userOwnerName', label: 'Ejecutivo', type: 'text' },
];
